import { createSlice } from '@reduxjs/toolkit'

export const menuReducer = createSlice({
  name: 'menuStore',
  initialState: {
    open: false,
    isManuallyToggled: false,
  },
  reducers: {
    toggleMenu: (state, action) => {
      state.open = action.payload
      state.isManuallyToggled = true
    },
  },
})

export default menuReducer
